module.exports = __webpack_public_path__ + "img/fr_version_history.3726a031.png";